<template>
  <section class="section-filters">
    <LeadsFiltersSelected :page-kind="pageKind" />
    <div class="filters-list">
      <LeadsFiltersDropdowns :pageKind="pageKind" :kindPrefix="kindPrefix" />
      <LeadsFiltersDate :pageKind="pageKind" />
    </div>
  </section>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import { LeadsPageKind } from "@/models/LeadsPageKind";
import LeadsFiltersSelected from "./LeadsFiltersSelected.vue";
import LeadsFiltersDropdowns from "./LeadsFiltersDropdowns.vue";
import LeadsFiltersDate from "./LeadsFiltersDate.vue";
import IconBase from "../IconBase.vue";
import IconUpdate from "../icons/IconUpdate.vue";
import { RefreshGridMode } from "@/models/leads/ContactForm";

@Component({
  components: {
    LeadsFiltersSelected,
    LeadsFiltersDropdowns,
    LeadsFiltersDate,
    IconBase,
    IconUpdate
  },
})
export default class LeadsFilters extends Vue {
  @Prop({ required: true }) readonly pageKind!: LeadsPageKind;
  @Prop({ required: true }) readonly kindPrefix!: string;

  @Action("setNeedToRefreshLeadsGrid", { namespace: "leadsModule" }) setNeedToRefreshLeadsGrid!: (needToRefreshLeadsGrid: RefreshGridMode) => void;

  LeadsFilter1SelectedOptions = [1, 2];
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.section-filters {
  .filters-list {
    display: flex;
    flex-wrap: wrap;
    padding: 25px 0 5px;
    margin: 0 -12px;

    @media (max-width: 991px) {
      margin: 0 -8px;
    }
  }
}
</style>
